import { LoginPage } from "@shared/features/auth/pages/LoginPage";
import {
  PLATFORM_RESET,
  USER_SET,
  usePlatformDispatch,
} from "@platform//PlatformContext";
import { useSignupDisabled } from "@platform/hooks/useSignupDisabled";
import { useClosePlatformAccess } from "@platform/hooks/useClosePlatformAccess";

export function PlatformLoginPage() {
  useClosePlatformAccess();

  const dispatch = usePlatformDispatch();

  const isSignupDisabled = useSignupDisabled();

  const redirectTo =
    new URLSearchParams(window.location.search).get("redirect") || "/dashboard";

  const onSuccess = (data: any) => {
    dispatch({
      type: USER_SET,
      payload: { user: data.userData, authToken: data.authToken },
    });
  };

  const onError = () => {
    dispatch({ type: PLATFORM_RESET });
  };

  return (
    <LoginPage
      onError={onError}
      onSuccess={onSuccess}
      redirectTo={redirectTo}
      hideSignupLink={isSignupDisabled}
    />
  );
}

export default PlatformLoginPage;
